import * as deviceDetect from "deviceDetect";
import * as modalController from "modalController";
import ReaderViewStore from "stores/ReaderViewStore";
import stores from "stores/stores";
import Dialog from "views/Dialog";

/**
 * Scroll-mode (video) texts don't paginate: a /from or /to route would leave
 * scroll mode and render a blank page, so navigation stays on the /scroll
 * route. The video seek is driven by the reader page, which sees every
 * navigation (see ReaderPageView.componentDidUpdate).
 */
const resolvePositionType = (
  pathname: string,
  fromOrTo: "from" | "to"
): "from" | "to" | "scroll" =>
  /^\/library\/[^/]+\/scroll(\/|$)/.test(pathname) ? "scroll" : fromOrTo;

export const goToLocation = (
  fromOrTo: "from" | "to",
  position: number,
  appRouter
) => {
  const positionType = resolvePositionType(window.location.pathname, fromOrTo);
  appRouter.navigate(
    `/library/${stores.bookModel.id}/${positionType}/${position}`,
    {
      trigger: true,
    }
  );
};

export const _functionsForUnitTests = { resolvePositionType };

export const showSpecificLocationModal = (
  appRouter,
  readerViewStore: ReaderViewStore
) => {
  let inputRef: any;

  const onSubmit = () => {
    const rawValue = inputRef.value;
    const value = parseInt(rawValue, 10);

    if (!value) {
      alert("Invalid value");
      return;
    }

    if (value < 0 || value > stores.bookModel.book.value.totalWords) {
      alert(
        "You need to enter a number between 0 and " +
          stores.bookModel.book.value.totalWords
      );
      return;
    }

    goToLocation("from", value, appRouter);
  };

  modalController.show(
    <Dialog heading="Go to specific location">
      <p>
        You are currently at location {readerViewStore.firstPosition.value ?? 0}
        .
      </p>
      <p>Enter location from 0 to {stores.bookModel.book.value.totalWords}:</p>
      <input
        autoFocus={!deviceDetect.isSmall()}
        type="text"
        inputMode="numeric"
        ref={(ref) => {
          inputRef = ref;
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            onSubmit();
          }
        }}
      />
      <p>
        <button
          onClick={() => {
            onSubmit();
          }}
        >
          Go to location
        </button>
      </p>
    </Dialog>,
    {
      onShow: () => {
        inputRef.focus();
      },
    }
  );
};
